import React, { useEffect, useState } from "react";
import { cmsUpdate, getCmslist } from "./actions";
import { useDispatch } from "react-redux";
import "./style.css";
import TextEditor from "../../components/textEditor";
import { STATIC_CONTENT_TYPE } from "../../utils/contentTypes";
import { CButton } from "@coreui/react-pro";
import ProperSpinner from "../../components/spinner/ProperSpinner";
import Faq from "./faq";

const faqs = [
  {
    question: "1. What is DevConnect?",
    answer:
      "DevConnect is a platform designed for developers to collaborate, share knowledge, and work on projects together. It offers tools for code sharing, discussions, and mentorship. Whether you are a beginner looking for guidance or an experienced developer wanting to contribute to the community, DevConnect provides a space to connect, learn, and grow. Our goal is to foster a supportive environment where developers can find answers, seek mentorship, and build amazing projects together.",
  },
  {
    question: "2. How can I sign up for DevConnect?",
    answer:
      "You can sign up by visiting our website and clicking on the 'Sign Up' button. Fill in your details, verify your email, and start exploring the platform.",
  },
  {
    question: "3. Is DevConnect free to use?",
    answer:
      "Yes, DevConnect offers a free plan with essential features. We also provide premium plans with additional benefits like priority support and advanced project management tools. The free plan is ideal for individuals looking to get started, while our premium plans cater to professional teams, offering enhanced collaboration tools, integrations with external services, and exclusive learning resources.",
  },
  {
    question: "4. Can I collaborate with other developers on projects?",
    answer:
      "Absolutely! DevConnect allows you to create and join projects, share code, and collaborate in real-time with other developers worldwide. The platform supports real-time messaging, version control integration, and project management tools to ensure a smooth workflow. Whether you are working on open-source projects, hackathons, or private team projects, DevConnect provides the necessary infrastructure to make collaboration seamless and efficient.",
  },
  {
    question: "5. Does DevConnect support version control integration?",
    answer:
      "Yes, DevConnect integrates with popular version control systems like GitHub, GitLab, and Bitbucket to help you manage your code efficiently.",
  },
  {
    question: "6. How can I find mentors on DevConnect?",
    answer:
      "You can browse our mentorship section, where experienced developers offer guidance and mentorship on various technologies and career growth. DevConnect’s mentorship program connects you with industry experts who provide personalized advice, review your code, and help you navigate your career path. You can schedule one-on-one sessions, participate in group discussions, and get insights from professionals in different domains.",
  },
  {
    question: "7. Is there a mobile app for DevConnect?",
    answer:
      "Currently, we offer a web-based platform, but a mobile app for iOS and Android is under development and will be released soon.",
  },
  {
    question: "8. What programming languages does DevConnect support?",
    answer:
      "DevConnect is language-agnostic, meaning developers can work with any programming language, including JavaScript, Python, Java, C++, and more.",
  },
  {
    question: "9. How can I report a bug or suggest a feature?",
    answer:
      "You can report bugs or suggest features through our feedback portal on the website. Our team actively reviews and implements community-driven suggestions.",
  },
  {
    question: "10. How do I delete my DevConnect account?",
    answer:
      "If you wish to delete your account, go to your profile settings and click on 'Delete Account'. Keep in mind that this action is irreversible.",
  },
];

const CMS = () => {
  const [cmsList, setCmsList] = useState([]);
  const [content, setContent] = useState("");
  const [selectedItem, setSeletedItem] = useState(1);
  const [cmsId, setCmsId] = useState("");
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  function onChange(e) {
    setContent(e.target.value);
  }
  const currentDataAndIdHandler = (id) => {
    // temp code
    if (id == 5) {
      return;
    }

    let data = "";
    for (let index = 0; index < cmsList.length; index++) {
      if (cmsList[index].type === id) {
        data += cmsList[index].description;
        if (cmsId.length < 1 || cmsId !== cmsList[index]._id) {
          setCmsId(cmsList[index]._id);
        }
      }
      setContent(data);
    }
  };

  const updateHandler = () => {
    dispatch(
      cmsUpdate({ description: content }, `?cmsId=${cmsId}`, () => getCms())
    );
  };

  const getCms = () => {
    dispatch(
      getCmslist((response) => {
        setCmsList(response);
        setContent(response[selectedItem - 1]?.description);
        setCmsId(response[selectedItem - 1]?._id);
        setLoading(false);
      })
    );
    currentDataAndIdHandler(selectedItem);
  };
  useEffect(() => {
    getCms();
  }, []);
  console.log('cms render');
  if (loading) {
    return <ProperSpinner />;
  }
  return (
    <div className="cms-main-container mt-3">
      <div className="cms-container">
        {STATIC_CONTENT_TYPE &&
          STATIC_CONTENT_TYPE.map((item) => {
            return (
              <div className="cms-navbar" key={item.name}>
                <div
                  onClick={() => {
                    setSeletedItem(item.type);
                    currentDataAndIdHandler(item.type);
                  }}
                  className={`nav-item ${item.type === selectedItem ? "seleted-item" : ""}`}
                  key={item.type}
                >
                  {item.name}
                </div>
              </div>
            );
          })}
      </div>
      <div className="mt-2">
        {selectedItem === 5 ? (
          <Faq faqs={faqs}/>
        ) : (
          <TextEditor value={content} onChange={onChange} />
        )}
      </div>
      <div className="cms-btn-container mt-3 fixed ">
        <CButton variant="outline" color="primary" onClick={updateHandler}>
          {"Update"}
        </CButton>
      </div>
    </div>
  );
};

export default CMS;
